var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"solo":"","hide-details":""},on:{"input":_vm.onValueChanged},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }